import { FormatTypeCopySink } from './format-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { BinaryDataset } from 'app/model/dataset/binary.dataset';

@Metamodel.model({
    name: 'BinarySink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(BinaryDataset) }
})
export class BinarySink extends FormatTypeCopySink {
    public static readonly MODEL: IModel;
}
